import { render } from "preact";
import type { ComponentType } from "preact";

/**
 * Mounts the components a page declares in its markup: <div data-island="verdict-strip"></div>.
 *
 * The anchors are laid out with `display: contents`, so they add a node to the tree and nothing to
 * the layout. An unknown name throws on the spot rather than leaving a silently empty page, which is
 * the failure a typo in a template would otherwise cause.
 */
export function mountIslands(registry: Record<string, ComponentType<Record<string, never>>>): void {
    document.querySelectorAll<HTMLElement>("[data-island]").forEach((anchor) => {
        const name = anchor.dataset.island!;
        const Component = registry[name];
        if (!Component) throw new Error(`Unknown island "${name}" on ${location.pathname}`);
        render(<Component />, anchor);
    });
}
